import React from "react";

export const camelToSnakeCase = str => str.replace(/[A-Z]/g, letter => `_${letter.toLowerCase()}`);

const useDataTableSorting = (props) => {
    const {initialSorting} = props ?? {};

    const [sorting, setSorting] = React.useState(initialSorting ? initialSorting : [])

    const sortingFetchOptions = React.useMemo(() => ({
        orderBy: sorting
            .map(({id, desc}) => `${desc ? "+" : "-"}${camelToSnakeCase(id)}`).join(","),
    }), [sorting]);

    return {
        sorting,
        onSortingChange: setSorting,
        sortingFetchOptions
    }
}

export default useDataTableSorting;